import React from 'react';

const PreviousWorkPage = () => {
  const previousWorks = [
    {
      id: 1,
      title: "CHENNAI SILK PALACE (LIFT FRAME) - KLANG",
      image: "/previous_work/CHENNAI SILK PALACE (LIFT FRAME) - KLANG.PNG",
    },
    {
      id: 2,
      title: "CHIN NAM TEMPLE- KUALA LUMPUR",
      image: "/previous_work/CHIN NAM TEMPLE- KUALA LUMPUR.PNG",
    },
    {
      id: 3,
      title: "CHOO SIAN TEMPLE - JLN GOMBAK",
      image: "/previous_work/CHOO SIAN TEMPLE - JLN GOMBAK.PNG",
    },
    {
      id: 4,
      title: "EXEMIA SDN. BHD. - PAVILLION KL",
      image: "/previous_work/EXEMIA SDN. BHD. - PAVILLION KL.PNG",
    },
    {
      id: 5,
      title: "OCR CONSTRUCTION SDN BHD- KUALA LUMPUR",
      image: "/previous_work/OCR CONSTRUCTION SDN BHD- KUALA LUMPUR.PNG",
    },
    {
      id: 6,
      title: "PEMBINAAN KARISMA PERWIRA- BM BANTING",
      image: "/previous_work/PEMBINAAN KARISMA PERWIRA- BM BANTING.PNG",
    },
    {
      id: 7,
      title: "PEMBINAAN KARISMA PERWIRA- SEREMBAN",
      image: "/previous_work/PEMBINAAN KARISMA PERWIRA- SEREMBAN.PNG",
    },
    {
      id: 8,
      title: "TAJUKON SDN. BHD. - SHAH ALAM",
      image: "/previous_work/TAJUKON SDN. BHD. - SHAH ALAM.PNG",
    },
    {
      id: 9,
      title: "THE LOTUS CONSTRUCTION- KLANG",
      image: "/previous_work/THE LOTUS CONSTRUCTION- KLANG.PNG",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-12 pt-20">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-8 sm:mb-12">Our Previous Work</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {previousWorks.map((work) => (
            <div key={work.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src={work.image} alt={work.title} className="w-full h-40 sm:h-48 object-cover" />
              <div className="p-4 sm:p-6">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">{work.title}</h2>
                {/* Additional details can go here if needed */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviousWorkPage;
